// import ssoImg1 from "./../../../../assets/images/708.png"; // Adjust the path as necessary
// import ssoImg2 from "./../../../../assets/images/283.png"; // Adjust the path as necessary
import img01 from "./../../../../assets/images/283.png";// Adjust the path as necessary
import Doc1 from "./../../../../Documents/OffshoreBunkering/SER-701-01-01 Service Request Form.pdf";
import Doc2 from "./../../../../Documents/OffshoreBunkering/BUNKER APPLICATION FORM.pdf";

function OffshoreBunkerOverview() {
  return (
    <>
      <div className="service-title font-700 mb-3 text-uppercase">
        Offshore Bunker
        <span className="text-orange-ef3e33 font-400"> Overview</span>
      </div>

      <div className="row g-3 g-sm-4 g-md-5">
        <div className="col-lg">
          <p className="text-primary-color mb-3">
            The anchorage of the Algoa Bay is part of the 2850 km coastline of the Southern region of South Africa. It has a maximum depth of up to 42 meters and is approximately 30 nautical miles (nm) away from the traffic of ship en-route to major shipping markets such as the Americas, Europe, Asia and Africa. It is also near two ports, namely the Port of Ngqura and the Port of Port Elizabeth, which are about 4.1 nautical miles away from the bunker station. Because of their proximity to the anchorage and integrated infrastructure, both ports are in a position to provide seamless support services to vessels anchored in the bay. Altogether, these benefits place Algoa Bay as the most desirable provider of Offshore services in South Africa to ships passing by, including bunkering.
          </p>
          <p className="text-primary-color mb-3">The offshore bunkering attracts ships to Algoa Bay and ships require other services and suppliers, which altogether form Off Port Limit (OPL) operations. SAMSA plays a regulatory role in offshore Ship to Ship bunkering services by vetting all vessels bunkering in Algoa Bay rigorously and ensuring that the highest safety standards are met as per local and international requirements. Vessels are vetted based on age, records of previous Port State Control (PSC)  ​inspe​ctions, management and, most importantly, documentation to ensure that they are insured for any possible accidents, including oil spills, as per international regulations.</p>


          <p className="text-primary-color mb-3 font-600">
            Marine Notices:
          </p>
          <p className="text-primary-color mb-3">Marine Notices* are issued by the authority from time to time and shall be complied with. Marine Notices listed below are a non-exhaustive list of relevant notices to offshore bunkering and OPL services:</p>

          <ul class="green-star-ul">
            <li>
              Marine Notice 6 of 1999 - South African Ship Reporting System (SAFREP).
            </li>
            <li>
              Marine Notice 2 of 2011 - Amendments to MARPOL Annex I from 1 January 2011
            </li>
            <li> Marine Notice 24 of 2012 - Direct Contact Telephone Number - Cape Town Radio.</li>
            <li>
              Marine Notice 3 of 2016 - Application for Permission to Conduct a Bunker or Fuel Transfer Operation Outside a Port of the Republic of South Africa.
            </li>
            <li>
              Marine Notice 12 of 2017 - Heeding of Marine Weather Forecasts.
            </li>
            <li>Marine Notice 13 of 2017 - Vessels Requiring a Place of Refuge for Repairs.</li>
            <li>
              Marine Notice 8 of 2020 - Reporting of oil spills and shipping casualties threatening pollution. (This Marine Notice is updated regularly and the latest notice to be obtained from SAMSA's website)
            </li>
          </ul>
          <ul className="trust">

            <li>The above list of Marine Notices is valid at the time of publication.</li>
            <li> <a href="/legislation?section=marine-notices">​Click here to Search for Marine Notices</a> </li>
          </ul>
          <p className="text-primary-color mb-3 font-600">Contacts</p>
          <p className="text-primary-color mb-3">
            SAMSA works in collaboration with other maritime government organisations to provide offshore services and below are the contacts:
          </p>

          <div className="row g-3 g-sm-3">
            <div className="col-lg-5 col-md-6 col-sm-6">
              <p className="font-17 text-primary-color"><b>SAMSA (Port of Ngqura)</b></p>
              <p className="font-17 text-primary-color">Tel: +27 (0) 79 512 1017</p><p className="font-17 text-primary-color">Email: <a href='mailto:OPLServicesPE@samsa.org.zaa'>OPLServicesPE@samsa.org.za</a></p>
            </div>

            <div className="col-lg-5 col-md-6 col-sm-6">
              <p className="font-17 text-primary-color"><b>TNPA Vessel Traffic Control</b></p>
              <p className="font-17 text-primary-color">Tel: +27 41 507 8444</p>
              <p className="font-17 text-primary-color">Email: <a href='mailto:VTS.Control@transnet.net'>VTS.Control@transnet.net</a></p>
            </div>

          </div>   <br />
          <div className="accordion blackTab" id="blackTab">
            <div className="accordion-item">
              <h2 className="accordion-header">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#blackTabOne"
                  aria-expanded="false"
                  aria-controls="blackTabOne"
                >
                  FORMS
                </button>
              </h2>
              <div
                id="blackTabOne"
                className="accordion-collapse collapse"
                data-bs-parent="#blackTab"
              >
                <div className="accordion-body">
                  {/* <p className="mb-3">Process, including the process flow and identification of the role players</p> */}

                  <ul class="green-star-ul">
                    <li><a href={Doc1}>Service Request Form</a></li>
                    <li><a href={Doc2}>Bunker Application Form</a></li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <div className="col-lg-5">
          <div className="row g-3 g-sm-3 g-md-4 g-lg-4">
            <div className="col-lg-12 col-md-6 col-sm-6">
              <img src={img01} className="img-fluid rounded-1" alt="" />
            </div>
            <div className="col-lg-12 col-md-6 col-sm-6">
              <img src={img01} className="img-fluid rounded-1" alt="" />
            </div>
          </div>          
        </div> */}


      </div>
    </>
  );
}

export default OffshoreBunkerOverview;